import { render, staticRenderFns } from "./associativeClassification.vue?vue&type=template&id=626679fe&scoped=true"
import script from "./associativeClassification.vue?vue&type=script&lang=js"
export * from "./associativeClassification.vue?vue&type=script&lang=js"
import style0 from "./associativeClassification.vue?vue&type=style&index=0&id=626679fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626679fe",
  null
  
)

export default component.exports